import { render, staticRenderFns } from "./index.vue?vue&type=template&id=347c02a7&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./dosageProduct.scss?vue&type=style&index=0&id=347c02a7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c02a7",
  null
  
)

export default component.exports